class FacetFiltersForm extends HTMLElement {
  self = this;
  constructor() {
    super();

    this.debouncedOnSubmit = this.debounce((event) => {
      document.querySelector('[data-loading]').classList.add('is-active');
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));
    this.filterToggle();
  }

  filterToggle() {
    const mainCollectionArea = document.querySelector("[js-main-collection-area]");
    const filterDetails = this.querySelectorAll("[js-filter-details]");
    filterDetails.forEach( details => {
      details.addEventListener("click", toggleFilterDetails)
    });
    function toggleFilterDetails() {
      filterDetails.forEach( item => {
        if(!this.contains(item)) item.removeAttribute("open");
      })
  
      setTimeout(() => {
        if (this.hasAttribute("open")) {
          const panelHeight = this.querySelector("[js-filter-panel]").clientHeight - 10;
          mainCollectionArea.style.paddingTop = `${panelHeight}px`;
        }else {
          mainCollectionArea.style.paddingTop = 0;
        }
      })
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      self.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sectionId = document.querySelector('[js-main-collection]').getAttribute('data-section-id');
    const url = `${window.location.pathname}?section_id=${sectionId}&${searchParams}`;
    this.renderSectionFromFetch(url);
    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  renderSectionFromFetch(url) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const docs = responseText;
        const html = new DOMParser().parseFromString(docs, 'text/html');

        const currentCollectionGrid = document.querySelector('[data-partial]');
        const ajaxCollectionGrid = html.querySelector('[data-partial]');

        if(currentCollectionGrid && ajaxCollectionGrid) {
            currentCollectionGrid.replaceWith(ajaxCollectionGrid);
        }

        document.dispatchEvent(new CustomEvent('collection-filter:init'))
        document.dispatchEvent(new CustomEvent('get-all-images-initialized:lazy'))
        document.dispatchEvent(new CustomEvent('media-slider:init'))
        document.dispatchEvent(new CustomEvent('image-card:init'))

        const filterDetails = this.querySelectorAll("[js-filter-details]");

        filterDetails.forEach( item => {
            item.removeAttribute("open");
        })
        document.querySelector('[data-loading]').classList.remove('is-active');

      });
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    this.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const filterForm = this.querySelector('form');
    const forms = [];
    forms.push(this.createSearchParams(filterForm));
    this.onSubmitForm(forms.join('&'), event);
  }

  removeQueryParam(param) {
    const url = new URL(window.location.href);
    const params = url.searchParams;
    params.delete(param);
    history.replaceState(null, '', url.toString());

    return window.location.href.slice(window.location.href.indexOf('?') + 1);
  }

  onActiveFilterClick(event) {
    event.preventDefault();

    let searchParams = '';

    if(event.currentTarget.hasAttribute('js-remove-sortby')) {
        searchParams = this.removeQueryParam('sort_by');
    } else {
      if(event.currentTarget?.href) {
        searchParams =
        event.currentTarget?.href.indexOf('?') == -1
          ? ''
          : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
      } 
    }

    this.renderPage(searchParams, null, true);
  }

}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a') || this.querySelector('[js-clear-filter]') || this.querySelector('[js-remove-sortby]');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);